<template>
  <div>
    <div
      class="kt-head kt-head--skin-dark kt-head--fit-x kt-head--fit-b notification-bg"
    >
      <h3 class="kt-head__title">User Notifications</h3>
      <ul
        class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-success kt-notification-item-padding-x"
        role="tablist"
      >
        <li class="nav-item">
          <a
            class="nav-link active show"
            data-toggle="tab"
            href="#topbar_notifications_notifications"
            role="tab"
            aria-selected="true"
          >
            New Notifications
          </a>
        </li>
      </ul>
      <div class="text-right">
        <v-btn
          text
          v-if="notifications.length"
          color="white"
          class="text-right"
          @click="markAllAsRead()"
        >
          Mark all as read
        </v-btn>
      </div>
    </div>
    <div class="tab-content">
      <div
        class="tab-pane active show"
        id="topbar_notifications_notifications"
        role="tabpanel"
      >
        <div
          class="kt-notification kt-margin-t-10 kt-margin-b-10 kt-scroll notification-height"
        >
          <span class="d-none"> {{ notificationCounter }}</span>
          <div
            id="notifications"
            class="d-flex align-items-center"
            v-for="notification in notifications"
            :key="notification.id"
          >
            <a @click="openPage(notification)" class="kt-notification__item">
              <div class="kt-notification__item-icon">
                <span
                  v-show="notification.read_at == null"
                  class="notification-unread"
                ></span>
              </div>
              <div class="kt-notification__item-details">
                <div class="kt-notification__item-title d-flex">
                  {{ notification.data.message }}
                </div>
              </div>
            </a>
          </div>
          <div
            class="tab-pane"
            id="topbar_notifications_logs"
            v-show="!notifications.length"
          >
            <div class="kt-grid kt-grid--ver" style="min-height: 150px">
              <div
                class="kt-grid kt-grid--hor kt-grid__item kt-grid__item--fluid kt-grid__item--middle"
              >
                <div
                  class="kt-grid__item kt-grid__item--middle kt-align-center"
                >
                  <br />No notifications.
                </div>
              </div>
            </div>
          </div>
          <div class="text-right">
            <v-btn
              text
              @click="fetchAllNotifications()"
              v-if="
                notifications.length && notifications.length < totalNotification
              "
              >Show more</v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../../../plugins/eventBus';

export default {
  props: ['notification'],
  name: 'DropNotification',
  data() {
    return {
      notifCounter: 0,
      notifTotalItem: 0,
    };
  },
  created() {
    if (this.$store.state.notifications.list.length)
      this.notifTotalItem = this.$store.state.notifications.list.length - 10;

    this.fetchAllNotifications();
    this.notification++;
  },
  computed: {
    notificationCounter() {
      return this.notifCounter;
    },
    notifications() {
      let notifcations = this.$store.state.notifications.list;

      return notifcations;
    },
    totalNotification() {
      return this.$store.state.notifications.unreadPagination.total;
    },
  },
  methods: {
    fetchAllNotifications() {
      this.notifTotalItem += 10;

      this.$store
        .dispatch('notifications/fetchAllNotifications', {
          page: 1,
          totalPage: this.notifTotalItem,
        })
        .then(({ data }) => {
          this.$store.commit('notifications/setNotifications', data.data);
          this.$store.commit('notifications/setUnreadPagination', {
            total: data.total,
            current_page: data.current_page,
          });

          this.totalUnread();
        });
    },
    markAsRead(notification) {
      const { id } = notification;
      this.axios.post('notifications/read', { id }).then(({ data }) => {
        this.fetchAllNotifications();
      });
    },
    markAllAsRead() {
      this.axios.post('notifications/read-all').then(({ data }) => {
        this.fetchAllNotifications();
      });
    },
    openPage(notification) {
      this.markAsRead(notification);

      if (this.isTypeProgressReport) {
        return window.open(notification.data.link);
      }

      if (!this.isTypeEventsOrVOTD(notification.type)) {
        return this.$router.push(notification.data.link);
      }
    },
    isTypeEventsOrVOTD(type) {
      const notifcationsTypes = [
        'App\\Notifications\\VideoOfTheDay',
        'App\\Notifications\\EventCalendar',
      ];

      return notifcationsTypes.includes(type);
    },

    isTypeProgressReport(type) {
      return 'App\Notifications\ProgressReportExportSent' == type;
    },

    totalUnread() {
      this.notifCounter = 0;

      if (this.notifications != null) {
        this.notifications.forEach((e) => {
          if (e.read_at == null) {
            this.notifCounter++;
          }
        });
      }

      EventBus.$emit('getNotifications', this.notifCounter);
    },
  },
};
</script>
<style lang="stylus" scoped>
.notification-bg
  background-image url('../../../../assets/images/notif-bg.jpg')
.notification-height
  max-height 300px
  overflow-y scroll
.kt-notification .kt-notification__item:after
  content none
.notification-unread
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background: #5570e7;
</style>
